import * as React from "react";

import NavTop from "./NavTop";
import DrawerMenu from "./DrawerMenu";
import ContentWrapper from "./ContentWrapper";

export default function PageTemplateOffline() {
  return (
    <div className="wib-page-template">
      <NavTop />
      <DrawerMenu />
      <ContentWrapper />
    </div>
  );
}
